import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';

import { ConfirmDialogService } from '../core/services/confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (dialog.state(); as state) {
      <div class="confirm-dialog-backdrop" (click)="dialog.cancel()"></div>

      <div class="confirm-dialog" role="dialog" aria-modal="true" [attr.aria-label]="state.title">
        <div class="confirm-dialog__surface surface-card">
          <div class="confirm-dialog__header">
            <h3 class="confirm-dialog__title">{{ state.title }}</h3>
          </div>

          <p class="confirm-dialog__message">{{ state.message }}</p>

          <div class="confirm-dialog__actions">
            <button type="button" class="btn-secondary" (click)="dialog.cancel()">
              {{ state.cancelLabel }}
            </button>
            <button
              type="button"
              [class]="state.tone === 'danger' ? 'btn-danger' : 'btn-primary'"
              (click)="dialog.accept()"
            >
              {{ state.confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    }
  `
})
export class ConfirmDialogComponent {
  readonly dialog = inject(ConfirmDialogService);

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.dialog.state()) {
      this.dialog.cancel();
    }
  }
}
